export default {
  firstList: [
    {
      key: '5',
      isSelect: true,
      isNumber: true, // 确保只响应合同分数的change事件
      needTip: true,
      name: '年签署份数',
      tip: '预估一年的合同使用量，数量越多，单份价格就越低',
      itemList: [
        { label: '100份/年', value: '5' },
        { label: '500份/年', value: '10' },
        { label: '1000份/年', value: '20' },
        { label: '2000份/年', value: '25' },
        { label: '2000份以上', value: '50' },
      ],
    },
    {
      key: '0',
      isSelect: false,
      needTip: true,
      name: '是否对接业务系统',
      tip: '是否要在各类业务系统中，如OA/ERP/CRM中发起签署及后续的管理',
      itemList: [
        { label: '是', value: '50' },
        { label: '否', value: '0' },
      ],
    },
    {
      key: '0',
      isSelect: false,
      name: '是否需要本地部署',
      needTip: true,
      tip: '是否要将电子签名服务部到企业的本地机房或云服务中',
      itemList: [
        { label: '是', value: '50' },
        { label: '否', value: '0' },
      ],
    },
    {
      key: '0',
      isSelect: false,
      name: '是否需要高级合同管理',
      needTip: true,
      tip: '比如合同归档、台账、统计、履约、包括纸质合同的管理等',
      itemList: [
        { label: '是', value: '50' },
        { label: '否', value: '0' },
      ],
    },
    {
      key: '5',
      isSelect: true,
      isNumber: false,
      name: '您的企业规模',
      needTip: false,
      tip: '',
      itemList: [
        { label: '1-100人', value: '5' },
        { label: '100-500', value: '10' },
        { label: '500-1000', value: '35' },
        { label: '1000以上', value: '100' },
      ],
    },
  ],
  priceList: [
    {
      key: '5',
      count: '100份签署流量包',
      price: '650',
      each: '低至6.5元/份',
      total1: '650/年',
      printCost: '1000元/年',
      LogisticsCosts: '1200元/年',
    },
    {
      key: '10',
      count: '500份签署流量包',
      price: '3000',
      each: '低至6.0元/份',
      total1: '3000/年',
      printCost: '5000元/年',
      LogisticsCosts: '6000元/年',
    },
    {
      key: '20',
      count: '1000份签署流量包',
      price: '5500',
      each: '低至5.5元/份',
      total1: '5500/年',
      printCost: '10000元/年',
      LogisticsCosts: '12000元/年',
    },
    {
      key: '25',
      count: '2000份签署流量包',
      price: '10000',
      each: '低至5.0元/份',
      total1: '10000/年',
      printCost: '20000元/年',
      LogisticsCosts: '24000元/年',
    },
    {
      key: '50',
      count: '2000份以上签署流量包',
      price: '联系商务报价',
      each: '',
      total1: '签署流量费',
      printCost: '至少20000元/年',
      LogisticsCosts: '至少24000元/年',
    },
  ],
  levelList: [
    {
      id: 0,
      versionList: [
        {
          id: 0,
          name: '基础版',
          for: '适用于个人及小微企业',
          tagList: ['全流程签署及证据保全能力', '模板服务，快速通过模板生成文件', '多客户端支持，随时查阅下载'],
        },
      ],
    },
    {
      id: 1,
      versionList: [
        {
          id: 0,
          name: '专业版',
          for: '适用于成长企业',
          tagList: [
            '丰富批处理能力，文件处理显著提效',
            '合同&用印审批，业务流程更合规',
            '便捷的签后管理，签署及管理一体化',
            '开放标准API， 各类业务深度融合',
          ],
        },
        {
          id: 1,
          name: '基础版',
          for: '适用于个人及小微企业',
          tagList: ['全流程签署及证据保全能力', '模板服务，快速通过模板生成文件', '多客户端支持，随时查阅下载'],
        },
      ],
    },
    {
      id: 2,
      versionList: [
        {
          id: 0,
          name: '高级版',
          for: '适用于中型以上规模企业',
          tagList: ['集团版多组织管理，多业务支持', '更智能高效的合同管理', '纸质合同统一线上管理', '10+高级功能进阶'],
        },
        {
          id: 1,
          name: '专业版',
          for: '适用于成长企业',
          tagList: [
            '丰富批处理能力，文件处理显著提效',
            '合同&用印审批，业务流程更合规',
            '便捷的签后管理，签署及管理一体化',
            '开放标准API， 各类业务深度融合',
          ],
        },
      ],
    },
    {
      id: 3,
      versionList: [
        {
          id: 0,
          name: '高级版',
          for: '适用于中型以上规模企业',
          tagList: ['集团版多组织管理，多业务支持', '更智能高效的合同管理', '纸质合同统一线上管理', '10+高级功能进阶'],
        },
      ],
    },
  ],
  controlList: ['仓储成本', '人力成本', '管理成本', '合规风险'],
}
